module.exports = __webpack_public_path__ + "img/title_back.787925ab.png";